import './PlanificationView.css';
import PlanificationView from './PlanificationView';

export default PlanificationView;
